<template>
<li class="menuArrow" @click="$router.push(to)">
    <a>{{title}}</a> 
    <!--<a><img :src="`${$store.state.dir}images/arrow_right.png`"></a>-->
    <!-- <router-link :to="to"><img :src="`${$store.state.dir}images/arrow_right.png`"></router-link> -->
</li>
</template>

<script>
    export default {
        name:'MenuItem',
        props: {
            title: String,
            to: {
                type:String,
                default: '/',
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>